var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.99834 2.3999c-3.0872 0-5.59844 2.51357-5.59844 5.60156v8.00004c0 3.0872 2.51357 5.5984 5.60156 5.5984h8.00004c3.0872 0 5.5984-2.5136 5.5984-5.6016v-7.99996c0-3.0872-2.5136-5.59844-5.6016-5.59844zm9.60156 3.2c.4416 0 .8.3584.8.8s-.3584.8-.8.8-.8-.3584-.8-.8.3584-.8.8-.8zm-5.6 1.6c2.6472 0 4.8 2.1528 4.8 4.8s-2.1528 4.8-4.8 4.8-4.8-2.1528-4.8-4.8 2.1528-4.8 4.8-4.8zm0 1.6c-.8487 0-1.6626.33714-2.26274.93726-.60012.60014-.93726 1.41404-.93726 2.26274s.33714 1.6626.93726 2.2627c.60014.6002 1.41404.9373 2.26274.9373s1.6626-.3371 2.2627-.9373c.6002-.6001.9373-1.414.9373-2.2627s-.3371-1.6626-.9373-2.26274c-.6001-.60012-1.414-.93726-2.2627-.93726z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a0189170fe6b057231f1f5136bad22d2.svg";
export { ForwardRef as ReactComponent };